const PARAGRAPH_QUESTION_ANSWER_SECTION = (uuid: string, language: string) => `
  blockDataUUID(uuid: "${uuid}", language: "${language}") {
    id
    type
    title
    uuid
    ... on QABlock {
      id
      abstractAnswer
      abstractQuestion
      answer
      answerQuestionTitle
      answerTitle
      prompt
      question
      title
      type
      uuid
    }
  }
`;

export default PARAGRAPH_QUESTION_ANSWER_SECTION;
